var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRoundSettingDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#a9a7a7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-user-round-cog-icon lucide-user-round-cog",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.305 19.53.923-.382"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.228 16.852-.923-.383"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.852 15.228-.383-.923"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.852 20.772-.383.924"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m19.148 15.228.383-.923"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m19.53 21.696-.382-.924"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21a8 8 0 0 1 10.434-7.62"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m20.772 16.852.924-.383"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m20.772 19.148.924.383"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8,
    r: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRoundSettingDisabled);
export default __webpack_public_path__ + "static/media/user-round-setting-disabled.a01878dc28b36032747d70171aea8de4.svg";
export { ForwardRef as ReactComponent };